import { parse } from 'date-fns'
import { getString } from '../../locale'
import { BufferReader } from '../../utils/bufferreader'

// const ProjectName = 's-controller-v3'

export enum ChipId {
    ESP32 = 0x0000,
    ESP32S2 = 0x0002,
    ESP32C3 = 0x0005,
    ESP32C6 = 0x0007,
    ESP32S3 = 0x0009,
    ESP32H2 = 0x000a,
    ESP32P4 = 0x0010,
    INVALID = 0xffff,
}

const EspImageHeaderMagic = 0xe9

type IEspImageHeader = {
    magic: number // uint8_t
    segmentCount: number // uint8_t
    spiMode: number // uint8_t: 4 (4 bits)
    spiSpeed: number // uint8_t: 4 (4 bits)
    spiSize: number // uint8_t
    entryAddr: number // uint32_t
    wpPin: number // uint8_t
    spiPinDrv: Uint8Array // uint8_t[3]
    chipId: number // uint16_t
    minChipRev: number // uint8_t
    reserved: Uint8Array // uint8_t[8]
    hashAppended: number // uint8_t
}

// type IEspImageSegmentHeader = {
//     loadAddr: number // uint32_t
//     dataLen: number // uint32_t
// }

const EspAppDescMagicWord = 0xabcd5432

type IEspAppDesc = {
    magicWord: number // uint32_t
    secureVersion: number // uint32_t
    // reserv1: number[] // uint32_t[2]
    version: string // char[32]
    projectName: string // char[32]
    time: string // char[16]
    date: string // char[16]
    idfVer: string // char[32]
    appElfSha256: Uint8Array // uint8_t[32]
    // reserv2: Uint8Array // uint32_t[20]
}

export type IEspApp = IEspAppDesc & { appElfSha256Str: string; dateTime: Date } & Pick<IEspImageHeader, 'chipId' | 'minChipRev'>

export function parseEspBin(base64Bin: string): IEspApp {
    const buffer = Buffer.from(base64Bin, 'base64')
    // console.log('buffer', buffer)

    const reader = new BufferReader(buffer)

    // IEspImageHeader
    const magic = reader.readUInt8()
    // console.log('magic', magic.toString(16))
    if (magic !== EspImageHeaderMagic) {
        throw new Error(getString('esp_bin_input.invalid_message'))
    }
    reader.skip(1) // segmentCount
    reader.skip(1) // spiMode
    reader.skip(1) // spiSpeed + spiSize
    reader.skip(4) // entryAddr
    reader.skip(1) // wpPin
    reader.skip(3) // spiPinDrv
    const chipId = reader.readUInt16()
    // console.log('chipId', chipId)
    const minChipRev = reader.readUInt8()
    // console.log('minChipRev', minChipRev)
    reader.skip(8) // reserved
    reader.skip(1) // hashAppended

    // IEspImageSegmentHeader
    reader.skip(4) // loadAddr
    reader.skip(4) // dataLen

    // const versionIndex = reader.searchIndexOfString(ProjectName)
    // // console.log('versionIndex', versionIndex)
    // if (versionIndex === -1) {
    //     throw new Error(getString('esp_bin_input.invalid_message'))
    // }

    // reader.offset =
    //     versionIndex -
    //     /** reserv1 */
    //     32 -
    //     /** secureVersion */
    //     8 -
    //     /** magicWord */
    //     8
    // console.log('reader.offset', reader.offset)

    const magicWord = reader.readUInt32()
    // console.log('magicWord', magicWord.toString(16))
    if (magicWord !== EspAppDescMagicWord) {
        throw new Error(getString('esp_bin_input.invalid_message'))
    }
    const secureVersion = reader.readUInt32()
    // console.log('secureVersion', secureVersion)
    Array.from({ length: 2 }).map(() => reader.readUInt32()) // reserv1
    //
    const version = reader.readNullTerminatedString(32)
    // console.log('version', version)
    const projectName = reader.readNullTerminatedString(32)
    // console.log('projectName', projectName)
    const time = reader.readNullTerminatedString(16)
    // console.log('time', time)
    const date = reader.readNullTerminatedString(16)
    // console.log('date', date)
    const dateTime = parse(`${date} ${time}`.replace(/\s+/g, ' '), 'MMM d yyyy HH:mm:ss', Date.now())
    // console.log('dateTime', `${date} ${time}`.replace(/\s+/g, ' '), dateTime)
    const idfVer = reader.readNullTerminatedString(32)
    // console.log('idfVer', idfVer)
    const appElfSha256 = reader.readUint8ArrayByLength(32)
    // console.log('appElfSha256', appElfSha256)
    const appElfSha256Str = appElfSha256.reduce((str, byte) => str + byte.toString(16), '')
    reader.skip(20) // reserv2

    return {
        magicWord,
        secureVersion,
        version,
        projectName,
        time,
        date,
        dateTime,
        idfVer,
        appElfSha256,
        appElfSha256Str,
        chipId,
        minChipRev,
    }
}
